// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2NBLK","overflowing":"ReadFullNote_overflowing__2FNUP"};